export default __webpack_public_path__ + "static/media/jpeg.9e59c105.svg";